import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import type { ProductListItemModel } from 'autogen/swagger/all';
import { Headline } from 'autogen/translation-keys/trans-website-product-giftbox';
import { Typography } from 'components/generic/typography';
import HorizontalProductItem from 'components/shared/productItem/components/HorizontalProductItem/HorizontalProductItem';

const Container = styled.div`
    display: grid;
    row-gap: ${({ theme }) => theme.Spacing8};
`;

function Giftbox({ giftbox, ...restProps }: { giftbox: ProductListItemModel }) {
    const { t } = useTranslation();

    return (
        <Container {...restProps}>
            <Typography.Body size="L" strong>
                {t(Headline)}
            </Typography.Body>
            <HorizontalProductItem model={giftbox} showBorder={false} favoriteModel={undefined} />
        </Container>
    );
}

export default Giftbox;
